import { useEffect, useState } from 'react';
import axios from 'axios';
import API from '../../utils/API';
import { addOrSubtractMinutes } from '../../utils/dateTimeUtil';
import { useCommonMessageAndSpinnerHandlers } from '../../hooks';

const useValidateClientDateTime = () => {
    const [hasClientDateTimeError, setHasClientDateTimeError] = useState(false);
    const { errorMessage } = useCommonMessageAndSpinnerHandlers();

    const validateClientDate = async () => {
        try {
            const response = await axios.get(API.COMMON.CURRENT_SERVER_TIME);
            const maxDate = addOrSubtractMinutes(new Date(response.data), 5).getTime();
            const minDate = addOrSubtractMinutes(new Date(response.data), -5).getTime();
            const currentDate = new Date().getTime();
            if (!(currentDate >= minDate && currentDate <= maxDate)) {
                setHasClientDateTimeError(true);
            }
        } catch (error) {
            const { message } = error as Error;
            errorMessage(message);
        }
    };

    useEffect(() => {
        validateClientDate();
    }, []);

    return hasClientDateTimeError;
};

export default useValidateClientDateTime;
